import React, { ReactNode } from "react";
import { QA_LABELS } from "../../utils/constants";
import { BackgroundImage } from "./styled-components";

export interface Props {
  children: ReactNode;
  backgroundSrc?: string;
}

const Body = ({ children, backgroundSrc }: Props) => (
  <div data-qa-label={QA_LABELS.BODY}>
    {children}
    {backgroundSrc && <BackgroundImage src={backgroundSrc} />}
  </div>
);

export default Body;
